module.exports = __webpack_public_path__ + "img/JXW.c7699684.png";